import type { SxStyle } from '@aibees/shared/theme';

export const checkIcon: SxStyle = {
  color: 'primary.500',
  fontSize: 22,
};

export const comingSoonPill: SxStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 32,
  px: 1.5,
  borderRadius: 16,
  bgcolor: 'grey.300',
};
